import type {
  TChangeUsernameParams,
  TGetInitialDataResponse,
} from '@kapitalist/contract/endpoints'
import {endpoints} from '@kapitalist/contract/endpoints'
import {mkPlayerUsername} from '@kapitalist/contract/types'
import {PostApi} from '~/api/client'
import globalDataMock from '~/api/endpoints/GetInitialData/mock'

export type TChangeUsernameResponse = TGetInitialDataResponse

const endpoint = endpoints.account.changeUsername

export default class ChangeUsername extends PostApi<typeof endpoint>() {
  constructor() {
    super(endpoint)
  }

  protected getMockResponse(params: TChangeUsernameParams): TChangeUsernameResponse {
    return {
      authenticatedPlayerDetails: {
        ...globalDataMock.authenticatedPlayerDetails,
        username: mkPlayerUsername(params.username),
      },
    }
  }

  protected transformResponse(r: TChangeUsernameResponse) {
    return r
  }
}
